(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["penlab-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('penlab-gallery')) {
  customElements.define('penlab-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track || this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.panels = Array.from(this.querySelectorAll('[data-gallery-panel]'));
      this.links = Array.from(this.querySelectorAll('[data-gallery-trigger]'));
      this.photos = this.panels.filter(p => p.dataset.galleryPanel !== 'video');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');

      const stop = () => {
        clearInterval(this.timer);
        this.timer = null;
      };

      const show = (panel, animate = true) => {
        if (!panel) return;
        this.track.scrollTo({
          left: panel.offsetLeft,
          behavior: animate && !this.motion.matches ? 'smooth' : 'instant'
        });
      };

      this.track.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || this.motion.matches ||
            this.photos.length < 2 || this.contains(document.activeElement) ||
            !matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        const current = this.panels.reduce((a, b) =>
          Math.abs(a.offsetLeft - this.track.scrollLeft) <
          Math.abs(b.offsetLeft - this.track.scrollLeft) ? a : b);

        if (current.dataset.galleryPanel === 'video') return;
        stop();
        let index = Math.max(0, this.photos.indexOf(current));
        this.timer = setInterval(() => {
          index = (index + 1) % this.photos.length;
          show(this.photos[index]);
        }, 1600);
      }, options);

      this.track.addEventListener('pointerleave', () => {
        const running = this.timer !== null && this.timer !== undefined;
        stop();
        if (running) show(this.photos[0], false);
      }, options);

      this.track.addEventListener('pointerdown', stop, options);
      this.track.addEventListener('wheel', stop, { ...options, passive: true });
      this.addEventListener('focusin', stop, options);
      this.motion.addEventListener('change', stop, options);

      this.addEventListener('click', event => {
        const link = event.target.closest('[data-gallery-trigger]');
        if (!link || !this.contains(link)) return;
        const panel = this.panels.find(p =>
          p.dataset.galleryPanel === link.dataset.galleryTrigger);
        if (!panel) return;
        event.preventDefault();
        stop();
        show(panel);
      }, options);

      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (!this.track.clientWidth) return;
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.links.forEach((link, i) => i === index ?
            link.setAttribute('aria-current', 'true') :
            link.removeAttribute('aria-current'));
          this.panels.forEach((panel, i) => {
            if (i !== index) panel.querySelectorAll('video').forEach(v => v.pause());
          });
        });
      }, { ...options, passive: true });

      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track ||
            !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        stop();
        this.track.scrollBy({
          left: this.track.clientWidth * (event.key === 'ArrowRight' ? 1 : -1),
          behavior: 'instant'
        });
      }, options);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
          this.querySelectorAll('video').forEach(v => v.pause());
        }
      }, options);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
      this.abort?.abort();
      this.abort = null;
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scribblerush-account-connection"] && !Shopify.designMode) return;
  try {
    class ScribbleRushAccountClient {
  constructor(config, env) {
    this.config = config;
    this.env = env;
    this.prefix = 'scribblerush-account-v1:' + config.clientId + ':';
    this.discoveryPromise = null;
    this.busy = false;
    this.generation = 0;
    if (new URL(config.origin).origin !== env.origin || !config.origin.startsWith('https://')) throw new Error('origin');
    if (new URL(config.callback).origin !== env.origin) throw new Error('callback');
  }
  read(key) {
    try { return JSON.parse(this.env.storage.getItem(this.prefix + key) || 'null'); }
    catch { this.env.storage.removeItem(this.prefix + key); return null; }
  }
  write(key, value) { this.env.storage.setItem(this.prefix + key, JSON.stringify(value)); }
  remove(key) { this.env.storage.removeItem(this.prefix + key); }
  random() { return this.encode(this.env.crypto.getRandomValues(new Uint8Array(32))); }
  encode(bytes) { return btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  endpoint(value) {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password || url.hash) throw new Error('endpoint');
    return url.href;
  }
  async request(url, options = {}) {
    const response = await this.env.fetch(url, {...options, credentials: 'omit', redirect: 'error', referrerPolicy: 'no-referrer', cache: 'no-store', signal: AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error(response.status === 401 ? 'expired' : 'connection');
    return response.json();
  }
  async discovery() {
    if (!this.discoveryPromise) {
      this.discoveryPromise = Promise.all([
        this.request(this.config.origin + '/.well-known/openid-configuration'),
        this.request(this.config.origin + '/.well-known/customer-account-api')
      ]).then(([auth, api]) => ({
        authorize: this.endpoint(auth.authorization_endpoint),
        token: this.endpoint(auth.token_endpoint),
        logout: this.endpoint(auth.end_session_endpoint),
        issuer: this.endpoint(auth.issuer),
        graphql: this.endpoint(api.graphql_api)
      })).catch(error => { this.discoveryPromise = null; throw error; });
    }
    return this.discoveryPromise;
  }
  async signIn() {
    if (this.busy) return;
    this.busy = true;
    const generation = ++this.generation;
    try {
      this.remove('session');
      const endpoints = await this.discovery();
      const verifier = this.random();
      const state = this.random();
      const nonce = this.random();
      const challenge = this.encode(new Uint8Array(await this.env.crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))));
      if (generation !== this.generation) throw new Error('cancelled');
      this.write('pending', {verifier, state, nonce, created: this.env.now(), callback: this.config.callback});
      const url = new URL(endpoints.authorize);
      url.search = new URLSearchParams({client_id: this.config.clientId, response_type: 'code', redirect_uri: this.config.callback, scope: 'openid email customer-account-api:full', state, nonce, code_challenge: challenge, code_challenge_method: 'S256'}).toString();
      this.env.navigate(url.href);
    } finally { this.busy = false; }
  }
  async identity(token, graphql) {
    const result = await this.request(graphql, {method: 'POST', headers: {'Content-Type': 'application/json', Authorization: token}, body: JSON.stringify({query: 'query ScribbleRushIdentity { customer { id } }'})});
    const id = result.data?.customer?.id;
    if (result.errors?.length || typeof id !== 'string' || !/^gid:\/\/shopify\/Customer\/\d+$/.test(id)) throw new Error('identity');
    return id;
  }
  validateIdToken(token, pending, endpoints) {
    if (typeof token !== 'string' || token.split('.').length !== 3) throw new Error('identity');
    const raw = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(raw), character => character.charCodeAt(0))));
    const audience = Array.isArray(payload.aud) ? payload.aud : [payload.aud];
    if (!audience.includes(this.config.clientId) || (audience.length > 1 && payload.azp !== this.config.clientId) || payload.nonce !== pending.nonce || payload.iss !== endpoints.issuer || !Number.isFinite(payload.exp) || payload.exp * 1000 <= this.env.now() || typeof payload.sub !== 'string') throw new Error('identity');
  }
  async finish(href) {
    const url = new URL(href);
    const params = url.searchParams;
    if (!params.has('code') && !params.has('error') && !params.has('state')) return false;
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');
    const duplicate = ['code', 'state', 'error'].some(key => params.getAll(key).length > 1);
    ['code', 'state', 'error', 'error_description', 'error_uri', 'iss', 'session_state'].forEach(key => params.delete(key));
    this.env.replace(url.href);
    const pending = this.read('pending');
    this.remove('pending');
    this.remove('session');
    const generation = ++this.generation;
    if (duplicate || !pending || typeof state !== 'string' || state !== pending.state || pending.callback !== this.config.callback || !Number.isFinite(pending.created) || this.env.now() - pending.created > 600000 || pending.created > this.env.now() || url.origin !== this.config.origin) throw new Error('expired_link');
    if (error) throw new Error(error === 'access_denied' ? 'cancelled' : 'connection');
    if (!code || code.length > 4096) throw new Error('expired_link');
    const endpoints = await this.discovery();
    const token = await this.request(endpoints.token, {method: 'POST', headers: {'Content-Type': 'application/x-www-form-urlencoded'}, body: new URLSearchParams({grant_type: 'authorization_code', client_id: this.config.clientId, redirect_uri: pending.callback, code, code_verifier: pending.verifier})});
    if (typeof token.access_token !== 'string' || !token.access_token || typeof token.token_type !== 'string' || token.token_type.toLowerCase() !== 'bearer' || !Number.isFinite(token.expires_in) || token.expires_in <= 60) throw new Error('identity');
    this.validateIdToken(token.id_token, pending, endpoints);
    const customerId = await this.identity(token.access_token, endpoints.graphql);
    if (generation !== this.generation) throw new Error('cancelled');
    this.write('session', {accessToken: token.access_token, idToken: token.id_token, customerId, expiresAt: this.env.now() + (token.expires_in - 60) * 1000});
    return true;
  }
  session() {
    const value = this.read('session');
    if (!value || !Number.isFinite(value.expiresAt) || value.expiresAt <= this.env.now() || typeof value.accessToken !== 'string' || !value.accessToken || typeof value.idToken !== 'string' || !/^gid:\/\/shopify\/Customer\/\d+$/.test(value.customerId || '')) {
      this.remove('session');
      return null;
    }
    return value;
  }
  async verifySession() {
    const session = this.session();
    if (!session) return false;
    const generation = this.generation;
    try {
      const endpoints = await this.discovery();
      const customerId = await this.identity(session.accessToken, endpoints.graphql);
      if (generation !== this.generation || customerId !== session.customerId) throw new Error('identity');
      return true;
    } catch (error) { this.remove('session'); throw error; }
  }
  async signOut() {
    ++this.generation;
    const session = this.session();
    this.remove('pending');
    this.remove('session');
    if (!session) return;
    const endpoints = await this.discovery();
    const url = new URL(endpoints.logout);
    url.search = new URLSearchParams({id_token_hint: session.idToken, post_logout_redirect_uri: this.config.callback}).toString();
    this.env.navigate(url.href);
  }
}

if (typeof customElements !== 'undefined' && !customElements.get('sr-account-connection')) {
  customElements.define('sr-account-connection', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.start().catch(error => this.showError(error));
    }
    show(message, connected = false) {
      this.querySelector('[data-account-status]').textContent = message;
      this.querySelector('[data-account-sign-in]').hidden = connected;
      this.querySelector('[data-account-sign-out]').hidden = !connected;
    }
    showError(error) {
      const key = error.message === 'expired_link' ? 'expired' : error.message === 'cancelled' ? 'cancelled' : 'error';
      this.show(this.dataset[key]);
    }
    async action(callback) {
      const buttons = [...this.querySelectorAll('button')];
      buttons.forEach(button => button.disabled = true);
      this.show(this.dataset.loading);
      try { await callback(); }
      catch (error) { this.showError(error); }
      finally { buttons.forEach(button => button.disabled = false); }
    }
    async start() {
      const config = {clientId: this.dataset.clientId, origin: this.dataset.origin, callback: this.dataset.callback};
      const client = new ScribbleRushAccountClient(config, {origin: location.origin, storage: sessionStorage, fetch: fetch.bind(window), crypto, now: Date.now, navigate: url => location.assign(url), replace: url => history.replaceState(null, '', url)});
      window.ScribbleRushAccount = client;
      this.querySelector('[data-account-sign-in]').addEventListener('click', () => this.action(() => client.signIn()));
      this.querySelector('[data-account-sign-out]').addEventListener('click', () => this.action(async () => { await client.signOut(); this.show(this.dataset.signedOut); }));
      this.querySelectorAll('button').forEach(button => button.disabled = true);
      try {
        const completed = await client.finish(location.href);
        const connected = completed || await client.verifySession();
        this.show(connected ? this.dataset.connected : this.dataset.signedOut, connected);
      } finally { this.querySelectorAll('button').forEach(button => button.disabled = false); }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scribblerush-saved-items"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('sr-saved-items')) return;
  class SavedItems extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.messages = JSON.parse(this.querySelector('[data-saved-messages]').textContent);
      this.dialog = this.querySelector('dialog');
      this.list = this.querySelector('[data-saved-list]');
      this.status = this.querySelector('[data-saved-status]');
      this.root = new URL(this.dataset.root, location.origin);
      this.items = [];
      this.urls = [];
      this.ready = this.openDatabase();
      document.addEventListener('click', event => {
        const open = event.target.closest('[data-sr-open-saved]');
        if (open) { event.preventDefault(); this.show(open); }
        const save = event.target.closest('[data-sr-save-pack]');
        if (save) { event.preventDefault(); this.savePack(save); }
      }, {signal});
      this.querySelector('[data-saved-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, {signal});
      this.dialog.addEventListener('close', () => this.opener?.focus(), {signal});
      this.list.addEventListener('click', event => {
        const button = event.target.closest('button[data-action]');
        if (button) this.act(button);
      }, {signal});
      this.channel = typeof BroadcastChannel === 'function' ? new BroadcastChannel('scribblerush-saved') : null;
      if (this.channel) this.channel.onmessage = () => this.refresh();
      this.ready.then(async () => {
        await this.refresh();
        let pending;
        try { pending = sessionStorage.getItem('scribblerush-resume'); sessionStorage.removeItem('scribblerush-resume'); } catch {}
        if (pending) {
          await customElements.whenDefined('scribblerush-wrap');
          const item = this.items.find(x => x.id === pending);
          if (item) this.resume(item);
        }
      }).catch(() => this.storageError());
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.channel?.close(); this.db?.close(); this.urls.forEach(url => URL.revokeObjectURL(url));
    }
    openDatabase() {
      return new Promise((resolve, reject) => {
        if (!window.indexedDB) { reject(new Error('storage')); return; }
        const request = indexedDB.open('scribblerush-saved-v1', 1);
        request.onupgradeneeded = () => request.result.createObjectStore('items', {keyPath:'id'});
        request.onerror = () => reject(request.error);
        request.onblocked = () => reject(new Error('blocked'));
        request.onsuccess = () => { this.db = request.result; this.db.onversionchange = () => this.db.close(); resolve(); };
      });
    }
    async readAll() {
      await this.ready;
      return new Promise((resolve, reject) => {
        const tx = this.db.transaction('items', 'readonly');
        const request = tx.objectStore('items').getAll();
        tx.oncomplete = () => resolve(request.result);
        tx.onerror = () => reject(tx.error); tx.onabort = () => reject(tx.error);
      });
    }
    async write(item, remove = false) {
      await this.ready;
      await new Promise((resolve, reject) => {
        const tx = this.db.transaction('items', 'readwrite');
        const store = tx.objectStore('items');
        if (remove) store.delete(item.id);
        else {
          const count = store.count();
          count.onsuccess = () => {
            const existing = store.get(item.id);
            existing.onsuccess = () => { if (!existing.result && count.result >= 40) tx.abort(); else store.put(item); };
          };
        }
        tx.oncomplete = resolve; tx.onerror = () => reject(tx.error); tx.onabort = () => reject(tx.error || new Error('limit'));
      });
      this.channel?.postMessage('changed');
      await this.refresh();
    }
    storageError() { this.status.textContent = this.messages.storage_error; }
    async refresh() {
      try {
        this.items = (await this.readAll()).filter(item => item && typeof item.id === 'string' && ['pack','design'].includes(item.kind) && [1,2,4,10].includes(item.count)).sort((a,b) => b.updated - a.updated);
        document.querySelectorAll('[data-sr-saved-count]').forEach(node => { node.textContent = String(this.items.length); });
        document.querySelectorAll('[data-sr-save-pack]').forEach(button => {
          const saved = this.items.some(item => item.id === 'pack:' + button.dataset.srSavePack);
          button.setAttribute('aria-pressed', String(saved));
          button.querySelector('[data-save-label]').textContent = saved ? this.messages.saved : this.messages.save_pack;
        });
        this.render();
      } catch { this.storageError(); }
    }
    async show(opener) {
      this.opener = opener; this.status.textContent = '';
      if (!this.dialog.open) this.dialog.showModal();
      await this.refresh();
    }
    async savePack(button) {
      if (button.disabled) return;
      button.disabled = true;
      try {
        const count = Number(button.dataset.srSavePack);
        if (![1,2,4,10].includes(count)) return;
        await this.write({id:'pack:' + count,kind:'pack',count,title:button.dataset.title.slice(0,120),image:button.dataset.image || '',updated:Date.now()});
        const notice = button.parentElement.querySelector('[data-save-notice]');
        if (notice) notice.textContent = this.messages.saved_here;
      } catch { await this.show(button); this.storageError(); }
      finally { button.disabled = false; }
    }
    async saveDesign(studio) {
      const button = studio.querySelector('[data-save-later]');
      const status = studio.querySelector('[data-save-later-status]');
      if (button.disabled || studio.savingLater) return;
      studio.savingLater = true; button.disabled = true;
      try {
        const project = studio.projectDocument();
        if (!project) { status.textContent = studio.querySelector('[data-project-status]').textContent; return; }
        const title = studio.querySelector('[data-design-name]').value.trim().slice(0,60) || this.messages.untitled;
        const canvas = document.createElement('canvas'); canvas.width = 600; canvas.height = 190;
        studio.render(); canvas.getContext('2d').drawImage(studio.pen, 0, 0, 600, 190);
        const preview = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
        const file = new Blob([JSON.stringify(project)], {type:'application/json'});
        if (file.size > 30 * 1024 * 1024) throw new Error('size');
        const id = studio.savedDesignId || 'design:' + crypto.randomUUID();
        await this.write({id,kind:'design',title,count:project.packCount,file,preview,updated:Date.now()});
        studio.savedDesignId = id;
        status.textContent = this.messages.design_saved;
      } catch { status.textContent = this.messages.storage_error; }
      finally { studio.savingLater = false; button.disabled = false; studio.render(); }
    }
    element(tag, text, className) { const node = document.createElement(tag); if (text) node.textContent = text; if (className) node.className = className; return node; }
    render() {
      this.urls.forEach(url => URL.revokeObjectURL(url)); this.urls = []; this.list.replaceChildren();
      this.querySelector('[data-saved-empty]').hidden = this.items.length > 0;
      for (const item of this.items) {
        const card = this.element('article', null, 'sr-saved-card');
        let src = '';
        if (item.kind === 'design' && item.preview instanceof Blob) { src = URL.createObjectURL(item.preview); this.urls.push(src); }
        if (item.kind === 'pack' && typeof item.image === 'string') {
          try { const url = new URL(item.image, location.origin); if (url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || url.origin === location.origin)) src = url.href; } catch {}
        }
        if (src) { const image = this.element('img'); image.src = src; image.alt = ''; image.loading = 'lazy'; card.append(image); }
        const content = this.element('div', null, 'sr-saved-card-copy');
        content.append(this.element('p', this.messages[item.kind === 'design' ? 'design_type' : 'pack_type'], 'sr-saved-type'),this.element('h3',String(item.title).slice(0,120)));
        const controls = this.element('div', null, 'sr-saved-actions');
        const actions = item.kind === 'design' ? ['resume','download','remove'] : ['browse','remove'];
        for (const action of actions) { const button = this.element('button',this.messages[action]); button.type = 'button'; button.dataset.action = action; button.dataset.id = item.id; controls.append(button); }
        content.append(controls); card.append(content); this.list.append(card);
      }
    }
    async act(button) {
      const item = this.items.find(x => x.id === button.dataset.id); if (!item) return;
      button.disabled = true;
      try {
        const action = button.dataset.action;
        if (action === 'remove') { await this.write(item, true); this.status.textContent = this.messages.removed; this.querySelector('[data-saved-close]').focus(); }
        if (action === 'download' && item.file instanceof Blob) {
          const url = URL.createObjectURL(item.file); const a = this.element('a'); a.href = url; a.download = 'scribblerush-design-project.json'; a.click(); setTimeout(() => URL.revokeObjectURL(url),1000);
        }
        if (action === 'resume') await this.resume(item);
        if (action === 'browse') { this.dialog.close(); const target = new URL(this.root); target.hash = 'pen-pack-' + item.count; this.keepPreview(target); location.assign(target.href); }
      } catch { this.storageError(); }
      finally { button.disabled = false; }
    }
    keepPreview(url) { for (const name of ['preview_theme_id','_fd','pb']) { const value = new URL(location.href).searchParams.get(name); if (value) url.searchParams.set(name,value); } }
    async resume(item) {
      const studio = Array.from(document.querySelectorAll('scribblerush-wrap')).find(node => Array.from(node.querySelectorAll('[data-pack] option')).some(option => Number(option.dataset.packCount) === item.count));
      if (!studio || typeof studio.importProject !== 'function') {
        sessionStorage.setItem('scribblerush-resume',item.id);
        const target = new URL(this.root); target.hash = 'customize'; this.keepPreview(target); location.assign(target.href); return;
      }
      if (!(item.file instanceof Blob)) throw new Error('file');
      const loaded = await studio.importProject(item.file);
      if (!loaded) { this.status.textContent = this.messages.load_error; return; }
      studio.savedDesignId = item.id;
      studio.querySelector('[data-design-name]').value = String(item.title).slice(0,60); studio.render();
      this.dialog.close(); studio.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      studio.querySelector('[data-design-name]').focus({preventScroll:true});
    }
  }
  customElements.define('sr-saved-items', SavedItems);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scribblerush-wrap-studio"] && !Shopify.designMode) return;
  try {
    (() => {
  const LIMIT = 10 * 1024 * 1024;
  const TOTAL = 20 * 1024 * 1024;
  const TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  function imagePlacement(state, artwork, w, h) {
    const iw=artwork.naturalWidth||artwork.width,ih=artwork.naturalHeight||artwork.height;
    const modern=state.fitVersion===2;
    const bounds=modern&&state.trim!==false&&artwork.srBounds?artwork.srBounds:{x:0,y:0,width:iw,height:ih};
    const quarter=state.rotation%180!==0,rw=quarter?bounds.height:bounds.width,rh=quarter?bounds.width:bounds.height;
    const box=modern&&state.layout==='Front'?{x:w*.04,y:h*.35,width:w*.92,height:h*.30}:modern&&state.layout==='Fit'?{x:w*.04,y:h*.04,width:w*.92,height:h*.92}:{x:0,y:0,width:w,height:h};
    const fitScale=Math.min(box.width/rw,box.height/rh);
    const repeatScale=Math.min(w/rw,h*(modern ? .30 : 1)/rh);
    const base=state.layout==='Fill'?Math.max(w/rw,h/rh):state.layout==='Repeat'?repeatScale:fitScale;
    const zoom=modern?Math.max(state.layout==='Fill'?100:25,Math.min(state.layout==='Fit'||state.layout==='Front'?100:300,state.zoom)):state.zoom;
    const scale=base*zoom/100,dw=bounds.width*scale,dh=bounds.height*scale,rotW=rw*scale,rotH=rh*scale;
    const x=Math.max(-100,Math.min(100,state.x)),y=Math.max(-100,Math.min(100,state.y));
    let cx=w/2+x*w/200,cy=h/2+y*h/200;
    if(modern&&state.layout!=='Repeat'){
      const availableX=state.layout==='Fill'?Math.max(0,rotW-w):Math.max(0,box.width-rotW);
      const availableY=state.layout==='Fill'?Math.max(0,rotH-h):Math.max(0,box.height-rotH);
      cx=box.x+box.width/2+x*availableX/200;cy=box.y+box.height/2+y*availableY/200;
    }
    const left=cx-rotW/2,top=cy-rotH/2,right=cx+rotW/2,bottom=cy+rotH/2;
    const area=Math.max(0,Math.min(w,right)-Math.max(0,left))*Math.max(0,Math.min(h,bottom)-Math.max(0,top));
    return {bounds,quarter,scale,dw,dh,rotW,rotH,cx,cy,left,top,right,bottom,zoom,visible:Math.max(0,Math.min(1,area/(rotW*rotH)))};
  }
  function normalizeFit(state) {
    if(state.fitVersion!==2)return;
    state.zoom=Math.max(state.layout==='Fill'?100:25,Math.min(state.layout==='Front'||state.layout==='Fit'?100:300,state.zoom));
    state.x=Math.max(-100,Math.min(100,state.x));state.y=Math.max(-100,Math.min(100,state.y));
  }
  function visibleBounds(canvas) {
    const w=canvas.width,h=canvas.height,pixels=canvas.getContext('2d').getImageData(0,0,w,h).data;
    let left=w,top=h,right=-1,bottom=-1;
    for(let y=0;y<h;y++)for(let x=0;x<w;x++)if(pixels[(y*w+x)*4+3]>0){left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);}
    return right<left?null:{x:left,y:top,width:right-left+1,height:bottom-top+1};
  }
  function paintWrap(ctx, state, artwork) {
    const w = ctx.canvas.width, h = ctx.canvas.height;
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = state.bg;
    ctx.fillRect(0, 0, w, h);
    if (state.style === 'Upload' && artwork) {
      const g=imagePlacement(state,artwork,w,h),{dw,dh,bounds}=g;
      ctx.save();ctx.translate(g.cx,g.cy);ctx.rotate(state.rotation*Math.PI/180);
      if(state.layout==='Repeat'){
        const tile=state.fitVersion===2&&state.trim!==false&&artwork.srTile?artwork.srTile:artwork;
        const extentX=(g.quarter?h:w)*1.6,extentY=(g.quarter?w:h)*1.6;
        ctx.scale(g.scale,g.scale);ctx.translate(-bounds.width/2,-bounds.height/2);ctx.fillStyle=ctx.createPattern(tile,'repeat');
        ctx.fillRect(-extentX/g.scale,-extentY/g.scale,extentX*2/g.scale,extentY*2/g.scale);
      }else ctx.drawImage(artwork,bounds.x,bounds.y,bounds.width,bounds.height,-dw/2,-dh/2,dw,dh);
      ctx.restore();
    } else if (state.style === 'Anime energy') {
      ctx.fillStyle = state.accent;
      for (let i = 0; i < 18; i++) {
        const x = i * w / 13 - w / 8;
        ctx.beginPath();ctx.moveTo(x, 0);ctx.lineTo(x + 95, 0);ctx.lineTo(x + 20, h);ctx.lineTo(x - 15, h);ctx.closePath();ctx.fill();
      }
      ctx.strokeStyle = '#ffffff';ctx.globalAlpha = .65;ctx.lineWidth = 3;
      for (let i = 0; i < 22; i++) { ctx.beginPath();ctx.moveTo(i * 58, 0);ctx.lineTo(i * 58 - 80, h);ctx.stroke(); }
      ctx.globalAlpha = 1;
    } else if (state.style === 'Cosmic waves') {
      ctx.strokeStyle = state.accent;
      for (let i = 0; i < 7; i++) {
        ctx.globalAlpha = .3 + i * .09;ctx.lineWidth = 5 + i * 2;
        ctx.beginPath();ctx.moveTo(-30, h * .1 + i * 17);
        ctx.bezierCurveTo(w * .24, -h * .4 + i * 25, w * .42, h * 1.4 - i * 20, w * .7, h * .3 + i * 10);
        ctx.bezierCurveTo(w * .88, -20 + i * 17, w, h * .8, w + 40, h * .4);ctx.stroke();
      }
      ctx.globalAlpha = 1;ctx.fillStyle = '#ffffff';
      for (let i = 0; i < 17; i++) {ctx.beginPath();ctx.arc((i * 173 + 35) % w, (i * 47 + 26) % h, i % 3 + 1.5, 0, Math.PI * 2);ctx.fill();}
    } else if (state.style === 'Candy checker') {
      const size = h / 3;ctx.fillStyle = state.accent;
      for (let y = 0; y < 4; y++) for (let x = 0; x < Math.ceil(w / size); x++) if ((x + y) % 2 === 0) ctx.fillRect(x * size, y * size, size, size);
    }
    if (state.style === 'Paw party') {
      ctx.fillStyle = state.accent;
      for(let x=30;x<w+80;x+=125)for(let y=32;y<h+60;y+=110){
        ctx.save();ctx.translate(x+(y>100?45:0),y);ctx.rotate(-.2);
        ctx.beginPath();ctx.ellipse(0,10,18,15,0,0,Math.PI*2);ctx.fill();
        for(const [px,py] of [[-21,-7],[-8,-18],[8,-18],[21,-7]]){ctx.beginPath();ctx.ellipse(px,py,7,9,0,0,Math.PI*2);ctx.fill();}ctx.restore();
      }
    } else if(state.style === 'Birthday burst') {
      for(let i=0;i<70;i++){ctx.save();ctx.translate((i*137+26)%w,(i*71+15)%h);ctx.rotate(i);ctx.fillStyle=i%3===0?'#ffffff':state.accent;ctx.fillRect(-3,-7,6,14);ctx.restore();}
    } else if(state.style === 'Better together') {
      ctx.fillStyle=state.accent;
      for(let x=45;x<w;x+=130)for(let y=55;y<h;y+=115){ctx.save();ctx.translate(x,y);ctx.scale(1.4,1.4);ctx.beginPath();ctx.moveTo(0,12);ctx.bezierCurveTo(-38,-8,-19,-30,0,-11);ctx.bezierCurveTo(19,-30,38,-8,0,12);ctx.fill();ctx.restore();}
    }
    if (state.text) {
      const fonts = { Bold: 'Arial, sans-serif', Classic: 'Georgia, serif', Casual: 'cursive' };
      let size = h * .32;ctx.textAlign = 'center';ctx.textBaseline = 'middle';
      ctx.font = '700 ' + size + 'px ' + fonts[state.font];
      while (ctx.measureText(state.text).width > w * .76 && size > 15) {size -= 1;ctx.font = '700 ' + size + 'px ' + fonts[state.font];}
      ctx.shadowColor = 'rgba(0,0,0,.28)';ctx.shadowBlur = 3;ctx.shadowOffsetY = 2;
      ctx.fillStyle = state.ink;ctx.fillText(state.text, w / 2, h / 2, w * .8);
      ctx.shadowBlur = 0;ctx.shadowOffsetY = 0;
    }
  }
  function paintPen(ctx, wrap, angle = 0) {
    const w = ctx.canvas.width, h = ctx.canvas.height;
    ctx.clearRect(0, 0, w, h);
    ctx.save();ctx.scale(w / 1200, h / 380);
    ctx.fillStyle = 'rgba(34,18,46,.13)';ctx.beginPath();ctx.ellipse(625, 263, 440, 12, 0, 0, Math.PI * 2);ctx.fill();
    ctx.save();ctx.translate(30, 20);ctx.rotate(-.055);ctx.translate(0,191);ctx.scale(1,(wrap.height*841/1200)/(Math.PI*103));ctx.translate(0,-191);
    const chrome = ctx.createLinearGradient(0, 130, 0, 254);
    [[0,'#8b8c96'],[.2,'#ffffff'],[.42,'#9b9ca8'],[.6,'#ffffff'],[.85,'#565560'],[1,'#c9cbd0']].forEach(([n,c])=>chrome.addColorStop(n,c));
    ctx.fillStyle = chrome;ctx.strokeStyle = '#6f6977';ctx.lineWidth = 2;
    ctx.beginPath();ctx.moveTo(28,191);ctx.lineTo(171,140);ctx.lineTo(171,242);ctx.closePath();ctx.fill();ctx.stroke();
    ctx.fillStyle = '#211929';ctx.beginPath();ctx.ellipse(31,191,5,3,0,0,Math.PI*2);ctx.fill();
    ctx.fillStyle = 'rgba(225,239,248,.7)';ctx.beginPath();ctx.roundRect(164,130,884,124,45);ctx.fill();ctx.stroke();
    ctx.save();ctx.beginPath();ctx.roundRect(181,141,841,103,28);ctx.clip();const radians=angle*Math.PI/180;
    for(let row=0;row<103;row++){
      const normal=Math.max(-1,Math.min(1,((row+.5)/103-.5)*2));
      const theta=Math.asin(normal);
      const source=((.5+(theta+radians)/(Math.PI*2))%1+1)%1;
      ctx.drawImage(wrap,0,Math.min(wrap.height-1,source*wrap.height),wrap.width,1,181,141+row,841,1.5);
    }
    const shade = ctx.createLinearGradient(0,141,0,244);shade.addColorStop(0,'rgba(255,255,255,.55)');shade.addColorStop(.2,'rgba(255,255,255,.06)');shade.addColorStop(.5,'rgba(255,255,255,0)');shade.addColorStop(1,'rgba(0,0,0,.32)');ctx.fillStyle=shade;ctx.fillRect(181,141,841,103);ctx.restore();
    ctx.fillStyle=chrome;ctx.beginPath();ctx.roundRect(1021,133,39,118,16);ctx.fill();ctx.stroke();
    ctx.beginPath();ctx.roundRect(1060,159,62,66,14);ctx.fill();ctx.stroke();
    if(Math.cos(radians)>.05){ctx.save();ctx.translate(0,55*(1-Math.cos(radians)));ctx.globalAlpha=Math.max(.15,Math.cos(radians));
    ctx.fillStyle='rgba(250,250,255,.7)';ctx.beginPath();ctx.moveTo(1029,130);ctx.bezierCurveTo(1025,101,957,106,923,109);ctx.lineTo(795,126);ctx.quadraticCurveTo(772,130,788,143);ctx.lineTo(1025,153);ctx.closePath();ctx.fill();ctx.stroke();
    ctx.restore();}
    ctx.strokeStyle='rgba(255,255,255,.8)';ctx.lineWidth=5;ctx.beginPath();ctx.moveTo(201,147);ctx.lineTo(1003,147);ctx.stroke();
    ctx.restore();ctx.restore();
  }
  const DEFAULT = {style:'Upload',bg:'#6428f2',accent:'#e8ff45',layout:'Front',fitVersion:2,trim:true,zoom:100,x:0,y:0,rotation:0,text:'',font:'Bold',ink:'#ffffff'};
  const TEMPLATES = [
    {id:'anime',category:'art',style:'Anime energy',bg:'#6428f2',accent:'#e8ff45',text:'YOUR ENERGY'},
    {id:'cosmic',category:'art',style:'Cosmic waves',bg:'#122e58',accent:'#53e4df',text:'STAY CURIOUS'},
    {id:'checker',category:'art',style:'Candy checker',bg:'#ff84b6',accent:'#ffe8a6',ink:'#29172b',text:'MAKE YOUR MARK'},
    {id:'paws',category:'pets',style:'Paw party',bg:'#e2f6e6',accent:'#268a76',ink:'#17372e',text:'PAW-SOME'},
    {id:'pet',category:'pets',style:'Upload',bg:'#ffe2ac',accent:'#bc6042',ink:'#342019',layout:'Repeat',text:''},
    {id:'family',category:'photos',style:'Upload',bg:'#d9edff',accent:'#3b72a6',ink:'#ffffff',layout:'Front',text:''},
    {id:'birthday',category:'gifts',style:'Birthday burst',bg:'#ff799d',accent:'#fff263',ink:'#321543',text:'HAPPY BIRTHDAY'},
    {id:'couples',category:'gifts',style:'Better together',bg:'#fff0e2',accent:'#f697af',ink:'#591e45',text:'YOU + ME'},
    {id:'business',category:'business',style:'Upload',bg:'#f5f5f0',accent:'#1c3952',ink:'#1c3952',layout:'Repeat',text:''},
    {id:'minimal',category:'art',style:'Minimal',bg:'#2d806a',accent:'#ebdbb8',ink:'#ffffff',text:'YOUR NAME'}
  ];
  const STYLES = [...new Set(['Upload',...TEMPLATES.map(t=>t.style)])];
  const KEYS = Object.keys(DEFAULT).filter(key=>key!=='fitVersion');
  function paintGift(ctx, pen, state) {
    ctx.clearRect(0,0,1000,560);ctx.fillStyle='#e8f1ed';ctx.fillRect(0,0,1000,560);
    ctx.fillStyle='rgba(25,31,29,.12)';ctx.beginPath();ctx.ellipse(510,440,415,45,0,0,Math.PI*2);ctx.fill();
    ctx.fillStyle='#bf9264';ctx.beginPath();ctx.roundRect(70,165,860,258,22);ctx.fill();
    ctx.fillStyle='#ead2ac';ctx.beginPath();ctx.roundRect(76,145,848,254,19);ctx.fill();
    ctx.fillStyle='#211c27';ctx.beginPath();ctx.roundRect(105,203,790,133,16);ctx.fill();
    ctx.drawImage(pen,107,159,780,247);
    ctx.fillStyle=state.bg;ctx.beginPath();ctx.roundRect(353,73,294,82,8);ctx.fill();
    const channels=state.bg.slice(1).match(/../g).map(v=>parseInt(v,16));ctx.fillStyle=channels[0]*.2126+channels[1]*.7152+channels[2]*.0722>145?'#17131f':'#ffffff';ctx.textAlign='center';ctx.font='700 28px Arial';ctx.fillText('ScribbleRush',500,108);
    ctx.font='14px Arial';ctx.fillText('MADE PERSONAL',500,132);
  }
  class ScribbleRushWrap extends HTMLElement {
    connectedCallback() {
      if(this.controller)return;
      this.controller=new AbortController();
      queueMicrotask(()=>this.initialize());
    }
    initialize() {
      if(!this.isConnected||!this.controller)return;
      this.form=this.querySelector('form');this.flat=this.querySelector('[data-flat-canvas]');this.pen=this.querySelector('[data-pen-canvas]');
      if(!this.form||!this.flat?.getContext('2d')||!this.pen?.getContext('2d'))return;
      this.q=key=>this.querySelector('[data-'+key+']');
      const q=this.q,signal=this.controller.signal;
      this.messages=JSON.parse(q('wrap-messages').textContent);
      this.slots=Array.from({length:10},()=>this.newSlot());this.active=0;this.mode='same';this.count=this.packCount();this.angle=0;this.importToken=0;
      this.file=q('upload');this.formSupported='onformdata' in this.form;this.loadingProject=false;
      for(const style of STYLES){if(!Array.from(q('style').options).some(o=>o.value===style)){const o=document.createElement('option');o.value=style;o.textContent=this.messages['tpl_'+({ 'Paw party':'paws','Birthday burst':'birthday','Better together':'couples'}[style])]||style;q('style').append(o);}}
      this.addEventListener('input',e=>{if(e.target===q('spin')){this.angle=Number(q('spin').value);this.paintView();return;}if(e.target===this.file||e.target===q('project-file'))return;if(['layout','zoom','x','y','rotation','trim'].some(k=>e.target===q(k)))this.current().state.fitVersion=2;this.capture();this.schedule();},{signal});
      this.addEventListener('change',e=>{
        if(e.target===this.file){this.loadFile();return;}
        if(e.target===q('project-file')){this.importProject(e.target.files[0]);return;}
        if(e.target===q('pack')){this.capture();this.count=this.packCount();this.active=Math.min(this.active,this.mode==='individual'?this.count-1:0);this.loadControls();}
        else if(e.target===q('mode')){this.capture();this.mode=q('mode').value;this.active=0;this.loadControls();}
        else if(e.target!==q('spin')){if(['layout','zoom','x','y','rotation','trim'].some(k=>e.target===q(k)))this.current().state.fitVersion=2;this.capture();}
        this.schedule();
      },{signal});
      this.addEventListener('click',e=>{
        const slot=e.target.closest('[data-slot]');if(slot){this.capture();this.active=Number(slot.dataset.slot);this.loadControls();this.render();return;}
        if(e.target.closest('[data-fit-turn]')){this.capture();this.current().state.rotation=(this.current().state.rotation+90)%360;this.loadControls();this.autoFit('Front');return;}
        const fit=e.target.closest('[data-fit]');if(fit){this.autoFit(fit.dataset.fit);return;}
        const template=e.target.closest('[data-template]');if(template){this.applyTemplate(template.dataset.template);return;}
        const filter=e.target.closest('[data-template-filter]');if(filter){this.filterTemplates(filter.dataset.templateFilter);return;}
        const angle=e.target.closest('[data-angle]');if(angle){this.angle=Number(angle.dataset.angle);q('spin').value=this.angle;this.paintView();}
      },{signal});
      q('clear-upload').addEventListener('click',()=>{const slot=this.current();slot.token++;slot.file=null;slot.image=null;slot.source=null;slot.width=0;slot.height=0;slot.busy=false;slot.error='';this.file.value='';this.render();},{signal});
      q('reset-position').addEventListener('click',()=>this.autoFit('Front'),{signal});
      q('copy-all').addEventListener('click',()=>{
        this.capture();const source=this.current();if(source.busy)return;
        for(let i=0;i<this.count;i++)if(i!==this.active){const token=this.slots[i].token+1;this.slots[i]={...source,state:{...source.state},token,busy:false};}
        q('project-status').textContent=this.messages.copied;this.render();
      },{signal});
      q('download').addEventListener('click',()=>{this.capture();this.render();this.downloadURL(this.flat.toDataURL('image/png'),'scribblerush-pen-'+(this.active+1)+'-wrap.png');},{signal});
      q('share').addEventListener('click',()=>this.sharePreview(),{signal});
      q('save-project').addEventListener('click',()=>this.saveProject(),{signal});
      const saveLater=()=>{const saved=document.querySelector('sr-saved-items');if(saved&&typeof saved.saveDesign==='function')saved.saveDesign(this);else q('save-later-status').textContent=this.messages.save_unavailable;};
      q('save-later')?.addEventListener('click',saveLater,{signal});
      q('save-copy')?.addEventListener('click',()=>{this.savedDesignId=null;saveLater();},{signal});
      q('load-project').addEventListener('click',()=>{q('project-file').value='';q('project-file').click();},{signal});
      q('gift').addEventListener('toggle',()=>{if(q('gift').open)this.paintView();},{signal});
      this.form.addEventListener('submit',e=>{
        this.capture();this.render();const issue=this.orderIssue();
        if(issue||!this.form.reportValidity()){e.preventDefault();q('order-status').textContent=issue||this.messages.pack_incomplete;return;}
        e.stopPropagation();
      },{signal,capture:true});
      this.form.addEventListener('formdata',e=>this.attachArtwork(e.formData),{signal});
      document.addEventListener('click',e=>{
        const link=e.target.closest('[data-open-wrap]');if(!link||link.getAttribute('href')!=='#'+this.id)return;
        const i=Array.from(q('pack').options).findIndex(o=>o.dataset.packCount===link.dataset.openWrap);
        if(i>=0){this.capture();q('pack').selectedIndex=i;this.count=this.packCount();this.active=Math.min(this.active,this.mode==='individual'?this.count-1:0);this.loadControls();this.render();}
      },{signal});
      let drag=null;
      this.pen.addEventListener('pointerdown',e=>{drag={x:e.clientX,angle:this.angle};this.pen.setPointerCapture?.(e.pointerId);},{signal});
      this.pen.addEventListener('pointermove',e=>{if(!drag)return;this.angle=((drag.angle+(e.clientX-drag.x)*.8)%360+360)%360;q('spin').value=Math.round(this.angle);this.paintView();},{signal});
      const end=()=>{drag=null;};this.pen.addEventListener('pointerup',end,{signal});this.pen.addEventListener('pointercancel',end,{signal});this.pen.addEventListener('lostpointercapture',end,{signal});
      if(typeof IntersectionObserver==='function'){this.observer=new IntersectionObserver(entries=>q('mobile-add').closest('.sr-wrap-mobile-bar').classList.toggle('is-visible',entries[0].isIntersecting));this.observer.observe(this);}else q('mobile-add').closest('.sr-wrap-mobile-bar').classList.add('is-visible');
      this.buildTemplates();this.loadControls();this.render();
    }
    disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();this.controller=null;this.importToken=(this.importToken||0)+1;this.slots?.forEach(s=>s.token++);if(this.frame)cancelAnimationFrame(this.frame);}
    newSlot(){return {state:{...DEFAULT},file:null,image:null,source:null,width:0,height:0,busy:false,error:'',token:0};}
    current(){return this.slots[this.active];}
    packCount(){return Math.max(1,Math.min(10,Number(this.q('pack').selectedOptions[0]?.dataset.packCount)||1));}
    effectiveMode(){return this.count>1?this.mode:'same';}
    relevant(){return this.slots.slice(0,this.effectiveMode()==='individual'?this.count:1);}
    ready(s){return !s.busy&&(s.state.style!=='Upload'||!!s.image&&(s.state.layout==='Repeat'||imagePlacement(s.state,s.image,1200,220).visible>0));}
    autoFit(layout='Front'){this.capture();Object.assign(this.current().state,{layout,zoom:100,x:0,y:0,fitVersion:2});this.angle=0;this.q('spin').value='0';this.loadControls();this.render();}
    capture(){if(!this.q||!this.slots)return;const state=this.current().state;for(const key of KEYS){const el=this.q(key);state[key]=typeof DEFAULT[key]==='number'?Number(el.value):typeof DEFAULT[key]==='boolean'?el.checked:el.value;}state.text=state.text.slice(0,40);normalizeFit(state);}
    loadControls(){const q=this.q,s=this.current();for(const key of KEYS){if(typeof DEFAULT[key]==='boolean')q(key).checked=s.state[key];else q(key).value=s.state[key];}this.file.value='';}
    schedule(){if(this.frame)cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{this.frame=null;this.render();});}
    paintView(){if(!this.q)return;paintPen(this.pen.getContext('2d'),this.flat,this.angle);this.q('spin-value').textContent=Math.round(this.angle)+'°';if(this.q('gift').open)paintGift(this.q('gift-canvas').getContext('2d'),this.pen,this.current().state);}
    render(){
      if(!this.q)return;
      const q=this.q,s=this.current(),state=s.state,custom=state.style==='Upload';
      this.querySelectorAll('fieldset').forEach(el=>el.disabled=this.loadingProject);
      normalizeFit(state);const modern=state.fitVersion===2;q('zoom').min=modern?(state.layout==='Fill'?'100':'25'):'50';q('zoom').max=modern&&(state.layout==='Front'||state.layout==='Fit')?'100':'300';q('zoom').value=state.zoom;q('zoom').step='1';
      this.file.disabled=false;this.file.required=false;q('fit-tools').hidden=!custom;q('adjust').hidden=!custom;q('accent').disabled=custom;
      q('zoom-value').textContent=state.zoom+'%';q('x-value').textContent=state.x;q('y-value').textContent=state.y;
      q('pack-mode').hidden=this.count===1;q('copy-all').hidden=this.effectiveMode()!=='individual';q('copy-all').disabled=!this.ready(s);
      paintWrap(this.flat.getContext('2d'),state,s.image);this.paintView();
      q('clear-upload').hidden=!s.file;
      q('file-status').dataset.error=String(!!s.error);
      q('file-status').textContent=s.busy?this.dataset.loading:s.error?s.error:s.file?this.dataset.fileReady+' '+s.file.name:custom?this.dataset.uploadNeeded:'';
      this.renderSlots();this.photoQuality();this.fitFeedback();this.syncProperties();
      const ready=this.relevant().filter(x=>this.ready(x)).length,total=this.relevant().length,issue=this.orderIssue(),option=q('pack').selectedOptions[0];
      const available=option?.dataset.available==='true'&&!!q('pack').value;
      q('price').textContent=option?.dataset.price||'';q('mobile-price').textContent=option?.dataset.price||'';
      q('pack-progress').textContent=ready+' / '+total+' '+this.messages.pack_progress;
      q('mobile-status').textContent=ready+'/'+total+' '+this.messages.mobile_designs;
      for(const button of [q('add'),q('mobile-add')]){button.disabled=!!issue;button.textContent=available?this.dataset.addLabel:this.dataset.unavailableLabel;}
      q('order-status').textContent=issue||this.messages.pack_complete;
      q('download').disabled=!this.ready(s)||this.loadingProject;q('share').disabled=q('download').disabled;
      q('save-project').disabled=this.loadingProject||this.slots.some(x=>x.busy);
      if(q('save-later')){q('save-later').disabled=q('save-project').disabled||!!this.savingLater;q('save-copy').disabled=q('save-project').disabled;q('save-copy').hidden=!this.savedDesignId;}
    }
    renderSlots(){
      const q=this.q,individual=this.effectiveMode()==='individual',container=q('slots');container.hidden=!individual;
      const expected=individual?this.count:0;
      if(container.children.length!==expected){container.replaceChildren();for(let i=0;i<expected;i++){const button=document.createElement('button');button.type='button';button.dataset.slot=i;container.append(button);}}
      Array.from(container.children).forEach((button,i)=>{const ready=this.ready(this.slots[i]);button.setAttribute('aria-pressed',String(i===this.active));button.dataset.ready=String(ready);button.textContent=this.messages.pen+' '+(i+1)+(ready?' ✓':'');button.setAttribute('aria-label',this.messages.pen+' '+(i+1)+': '+(ready?this.messages.done:this.messages.needs_art));});
    }
    photoQuality(){
      const s=this.current(),q=this.q,el=q('quality');el.hidden=s.state.style!=='Upload'||!s.image;
      if(el.hidden){el.textContent='';return;}
      const g=imagePlacement(s.state,s.image,1200,220),ratio=g.scale*s.image.width/s.width;
      const low=ratio>1.25;el.dataset.level=low?'low':'good';
      el.textContent=s.width+' × '+s.height+' px · '+this.messages[low?'quality_low':'quality_good']+' '+this.messages.quality_note;
    }
    fitFeedback(){
      const q=this.q,s=this.current(),el=q('fit-status');
      el.hidden=s.state.style!=='Upload'||!s.image;if(el.hidden){el.textContent='';return;}
      const g=imagePlacement(s.state,s.image,1200,220),crop=Math.round((1-g.visible)*100);
      const key=s.state.layout==='Repeat'?'fit_repeated':crop>0?'fit_cropped':s.state.layout==='Front'?'fit_front_good':'fit_full_good';
      el.dataset.level=crop>0&&s.state.layout!=='Repeat'?'warning':'good';
      el.textContent=this.messages[key].replace('{percent}',String(crop));
      if(s.state.fitVersion!==2)el.textContent+=' '+this.messages.fit_legacy;
      if(s.state.layout==='Front'&&g.rotW<120)el.textContent+=' '+this.messages.fit_narrow;
      this.querySelectorAll('[data-fit]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.fit===s.state.layout)));

    }
    orderIssue(){
      const option=this.q('pack').selectedOptions[0];
      if(option?.dataset.available!=='true'||!this.q('pack').value)return this.dataset.unavailableLabel;
      if(!this.formSupported)return this.messages.form_unsupported;
      if(this.loadingProject||this.relevant().some(s=>!this.ready(s)))return this.messages.pack_incomplete;
      if(this.relevant().reduce((sum,s)=>sum+(s.state.style==='Upload'?(s.file?.size||0):0),0)>TOTAL)return this.messages.total_large;
      return '';
    }
    syncProperties(){
      const container=this.q('property-fields');container.replaceChildren();
      const add=(name,value)=>{if(value===undefined||value==='')return;const input=document.createElement('input');input.type='hidden';input.name='properties['+name+']';input.value=String(value);container.append(input);};
      add('Design applies to',this.messages[this.effectiveMode()==='individual'?'different_pack':'same_pack']);
      this.relevant().forEach((slot,i)=>{
        const s=slot.state,prefix=this.effectiveMode()==='individual'?'Pen '+(i+1)+' — ':'';
        add(prefix+'Wrap style',s.style);add(prefix+'Colors',s.bg+(s.style==='Upload'?'':' / '+s.accent));
        if(s.text)add(prefix+'Personalization',s.text+' ('+s.font+', '+s.ink+')');
        if(s.style==='Upload'){add(prefix+'Placement',s.layout+'; zoom '+s.zoom+'%; x '+s.x+'%; y '+s.y+'%; rotation '+s.rotation+'°; trim transparent borders '+(s.trim?'on':'off'));}
      });
      add('_Wrap configuration',JSON.stringify({version:3,mode:this.effectiveMode(),count:this.count,designs:this.relevant().map(s=>({...s.state,sourceBounds:s.image?.srBounds||null,previewImageWidth:s.image?.width||null,previewImageHeight:s.image?.height||null}))}));
    }
    attachArtwork(data){
      const canvas=document.createElement('canvas');canvas.width=1200;canvas.height=220;
      this.relevant().forEach((slot,i)=>{
        const prefix=this.effectiveMode()==='individual'?'Pen '+(i+1)+' — ':'';
        if(slot.state.style==='Upload'&&slot.file)data.set('properties['+prefix+'Artwork]',slot.file,slot.file.name);
        if(this.ready(slot)){paintWrap(canvas.getContext('2d'),slot.state,slot.image);data.set('properties['+prefix+'Design preview]',this.pngBlob(canvas),'scribblerush-pen-'+(i+1)+'-wrap.png');}
      });
    }
    pngBlob(canvas){const bytes=atob(canvas.toDataURL('image/png').split(',')[1]),array=new Uint8Array(bytes.length);for(let i=0;i<bytes.length;i++)array[i]=bytes.charCodeAt(i);return new Blob([array],{type:'image/png'});}
    async decodeFile(file){
      if(!TYPES.includes(file.type)||file.size>LIMIT)throw new Error(this.dataset.fileError);
      const source=await new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(reader.result);reader.onerror=()=>reject(new Error(this.dataset.decodeError));reader.readAsDataURL(file);});
      const image=await new Promise((resolve,reject)=>{const img=new Image();img.onload=()=>resolve(img);img.onerror=()=>reject(new Error(this.dataset.decodeError));img.src=source;});
      const width=image.naturalWidth,height=image.naturalHeight;
      if(!width||!height||width>16000||height>16000||width*height>64000000||width/height>30||height/width>30)throw new Error(this.dataset.decodeError);
      const canvas=document.createElement('canvas'),scale=Math.min(1,1800/Math.max(width,height));canvas.width=Math.round(width*scale);canvas.height=Math.round(height*scale);canvas.getContext('2d').drawImage(image,0,0,canvas.width,canvas.height);
      canvas.srBounds=visibleBounds(canvas);if(!canvas.srBounds)throw new Error(this.messages.empty_image);
      const bounds=canvas.srBounds,tile=document.createElement('canvas');tile.width=bounds.width;tile.height=bounds.height;tile.getContext('2d').drawImage(canvas,bounds.x,bounds.y,bounds.width,bounds.height,0,0,bounds.width,bounds.height);canvas.srTile=tile;
      return {source,image:canvas,width,height};
    }
    async loadFile(){
      const file=this.file.files[0];if(!file)return;
      this.capture();const slot=this.current(),token=++slot.token;slot.state.style='Upload';slot.file=null;slot.image=null;slot.source=null;slot.error='';slot.busy=true;this.q('style').value='Upload';this.render();
      try{const decoded=await this.decodeFile(file);if(slot.token!==token||!this.isConnected)return;Object.assign(slot,decoded,{file,busy:false});Object.assign(slot.state,{layout:'Front',fitVersion:2,trim:true,zoom:100,x:0,y:0,rotation:0});if(slot===this.current()){this.angle=0;this.q('spin').value='0';this.loadControls();}}
      catch(error){if(slot.token!==token)return;slot.busy=false;slot.error=error.message;}
      if(this.isConnected)this.render();
    }
    buildTemplates(){
      const grid=this.q('template-grid');grid.replaceChildren();
      for(const template of TEMPLATES){
        const button=document.createElement('button');button.type='button';button.className='sr-template';button.dataset.template=template.id;button.dataset.category=template.category;
        const canvas=document.createElement('canvas');canvas.width=480;canvas.height=150;canvas.setAttribute('aria-hidden','true');
        const state={...DEFAULT,...template,text:''};paintWrap(canvas.getContext('2d'),state,null);
        if(template.style==='Upload'){
          const ctx=canvas.getContext('2d');ctx.fillStyle=template.accent;
          if(template.id==='pet'){
            for(const x of [140,340]){ctx.save();ctx.translate(x,76);ctx.beginPath();ctx.moveTo(-45,-12);ctx.lineTo(-43,-55);ctx.lineTo(-13,-31);ctx.lineTo(13,-31);ctx.lineTo(43,-55);ctx.lineTo(45,-12);ctx.ellipse(0,0,49,39,0,0,Math.PI*2);ctx.fill();ctx.fillStyle=template.bg;ctx.beginPath();ctx.arc(-17,-3,5,0,Math.PI*2);ctx.arc(17,-3,5,0,Math.PI*2);ctx.fill();ctx.beginPath();ctx.moveTo(-5,12);ctx.lineTo(5,12);ctx.lineTo(0,20);ctx.closePath();ctx.fill();ctx.restore();}
          }else if(template.id==='business'){
            ctx.save();ctx.translate(240,74);ctx.rotate(Math.PI/4);ctx.fillRect(-38,-38,76,76);ctx.fillStyle=template.bg;ctx.fillRect(-20,-20,40,40);ctx.restore();
          }else{
            ctx.globalAlpha=.38;for(const x of [100,240,380]){ctx.beginPath();ctx.arc(x,56,25,0,Math.PI*2);ctx.fill();ctx.beginPath();ctx.roundRect(x-38,87,76,46,20);ctx.fill();}ctx.globalAlpha=1;
          }
        }
        const name=document.createElement('strong');name.textContent=this.messages['tpl_'+template.id];
        const hint=document.createElement('span');hint.textContent=this.messages[template.style==='Upload'?(template.id==='business'?'logo_required':'photo_required'):'pattern_ready'];
        button.append(canvas,name,hint);grid.append(button);
      }
    }
    filterTemplates(category){
      this.querySelectorAll('[data-template]').forEach(b=>b.hidden=category!=='all'&&b.dataset.category!==category);
      this.querySelectorAll('[data-template-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.templateFilter===category)));
    }
    applyTemplate(id){const template=TEMPLATES.find(x=>x.id===id);if(!template)return;this.capture();this.current().state={...DEFAULT,...Object.fromEntries(KEYS.filter(k=>k in template).map(k=>[k,template[k]]))};this.loadControls();this.render();}
    downloadURL(url,name){const a=document.createElement('a');a.href=url;a.download=name;document.body.append(a);a.click();a.remove();}
    downloadBlob(blob,name){const url=URL.createObjectURL(blob);this.downloadURL(url,name);setTimeout(()=>URL.revokeObjectURL(url),1000);}
    async sharePreview(){
      this.capture();this.render();if(!this.ready(this.current()))return;
      const canvas=document.createElement('canvas');canvas.width=1200;canvas.height=460;const ctx=canvas.getContext('2d');ctx.fillStyle='#fffdf4';ctx.fillRect(0,0,1200,460);ctx.fillStyle='#6428f2';ctx.font='700 30px Arial';ctx.fillText('ScribbleRush',45,55);ctx.drawImage(this.pen,0,50);
      const file=new File([this.pngBlob(canvas)],'scribblerush-pen-preview.png',{type:'image/png'});
      try{if(navigator.canShare?.({files:[file]})&&navigator.share){await navigator.share({files:[file],title:'My ScribbleRush design'});this.q('project-status').textContent=this.messages.shared;}
      else{this.downloadBlob(file,file.name);this.q('project-status').textContent=this.messages.share_downloaded;}}
      catch(error){if(error.name!=='AbortError')this.q('project-status').textContent=this.messages.share_failed;}
    }
    projectDocument(){
      this.capture();if(this.loadingProject||this.slots.some(s=>s.busy)){this.q('project-status').textContent=this.messages.project_busy;return null;}
      const total=this.relevant().reduce((sum,s)=>sum+(s.state.style==='Upload'?(s.file?.size||0):0),0);
      if(total>TOTAL){this.q('project-status').textContent=this.messages.total_large;return null;}
      const quantity=Number(this.form.elements.quantity.value);
      return {app:'ScribbleRush',version:3,packCount:this.count,mode:this.effectiveMode(),quantity:Number.isSafeInteger(quantity)&&quantity>0?quantity:1,notes:this.q('notes').value,designs:this.relevant().map(s=>({state:{...s.state},art:s.state.style==='Upload'&&s.file?{name:s.file.name,type:s.file.type,data:s.source}:null}))};
    }
    saveProject(){
      const content=this.projectDocument();if(!content)return;
      this.downloadBlob(new Blob([JSON.stringify(content)],{type:'application/json'}),'scribblerush-design-project.json');this.q('project-status').textContent=this.messages.project_saved;
    }
    cleanState(raw){
      if(!raw||typeof raw!=='object'||!STYLES.includes(raw.style))throw new Error('state');
      const s={...DEFAULT,fitVersion:raw.fitVersion===undefined?1:raw.fitVersion,trim:raw.trim===undefined?false:raw.trim};if(![1,2].includes(s.fitVersion)||typeof s.trim!=='boolean')throw new Error('fit');
      for(const key of ['bg','accent','ink']){if(!/^#[\da-f]{6}$/i.test(raw[key]))throw new Error('color');s[key]=raw[key];}
      for(const [key,min,max] of [['zoom',25,300],['x',-100,100],['y',-100,100]]){if(!Number.isFinite(raw[key])||raw[key]<min||raw[key]>max)throw new Error('range');s[key]=raw[key];}
      if(![0,90,180,270].includes(raw.rotation)||!['Front','Fit','Fill','Repeat'].includes(raw.layout)||!['Bold','Classic','Casual'].includes(raw.font)||typeof raw.text!=='string'||raw.text.length>40)throw new Error('field');
      return {...s,style:raw.style,rotation:raw.rotation,layout:raw.layout,font:raw.font,text:raw.text};
    }
    async importProject(file){
      if(!file)return;const status=this.q('project-status'),token=++this.importToken;
      if(file.size>30*1024*1024){status.textContent=this.messages.project_invalid;return;}
      this.loadingProject=true;status.textContent=this.messages.project_loading;this.render();
      try{
        const raw=await new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(reader.result);reader.onerror=reject;reader.readAsText(file);}),doc=JSON.parse(raw);
        if(doc.app!=='ScribbleRush'||![2,3].includes(doc.version)||![1,2,4,10].includes(doc.packCount)||!['same','individual'].includes(doc.mode)||!Array.isArray(doc.designs)||doc.designs.length!==(doc.mode==='individual'?doc.packCount:1)||typeof doc.notes!=='string'||doc.notes.length>1000)throw new Error('project');
        const slots=Array.from({length:10},()=>this.newSlot());let bytes=0;
        for(let i=0;i<doc.designs.length;i++){
          const design=doc.designs[i],slot=slots[i];slot.state=this.cleanState(design.state);
          if(design.art){const art=design.art;if(!TYPES.includes(art.type)||typeof art.name!=='string'||art.name.length>255||typeof art.data!=='string'||!art.data.startsWith('data:'+art.type+';base64,'))throw new Error('art');
            const binary=atob(art.data.split(',')[1]),buffer=new Uint8Array(binary.length);for(let j=0;j<binary.length;j++)buffer[j]=binary.charCodeAt(j);bytes+=buffer.length;if(bytes>TOTAL)throw new Error('size');
            const photo=new File([buffer],art.name.replace(/[\x00-\x1f/\\]/g,'_'),{type:art.type});Object.assign(slot,await this.decodeFile(photo),{file:photo});
          }
          if(token!==this.importToken||!this.isConnected)return;
        }
        if(token!==this.importToken||!this.isConnected)return;
        const index=Array.from(this.q('pack').options).findIndex(o=>Number(o.dataset.packCount)===doc.packCount);
        if(index<0)throw new Error('pack');
        this.slots.forEach(s=>s.token++);this.slots=slots;this.q('pack').selectedIndex=index;this.form.elements.quantity.value=Number.isSafeInteger(doc.quantity)&&doc.quantity>0?doc.quantity:1;this.count=doc.packCount;this.mode=doc.mode;this.q('mode').value=doc.mode;this.active=0;this.q('notes').value=doc.notes;this.loadControls();status.textContent=this.messages.project_loaded;this.savedDesignId=null;if(this.q('design-name'))this.q('design-name').value='';return true;
      }catch(error){if(token===this.importToken)status.textContent=this.messages.project_invalid;return false;}
      finally{if(token===this.importToken){this.loadingProject=false;if(this.isConnected)this.render();}}
    }
  }
  if(!customElements.get('scribblerush-wrap'))customElements.define('scribblerush-wrap',ScribbleRushWrap);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sr-mug-feature-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sr-mug-feature-gallery')) {
  customElements.define('sr-mug-feature-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.thumbs = [...this.querySelectorAll('[data-mug-feature-design]')];
      this.photo = this.querySelector('.sr-mug-feature-photo');
      this.caption = this.querySelector('[data-mug-feature-name]');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-mug-feature-design]');
        if (button && this.contains(button)) this.select(button);
      });
      this.addEventListener('keydown', event => {
        const index = this.thumbs.indexOf(event.target);
        if (index < 0) return;
        const directions = {ArrowDown:1, ArrowRight:1, ArrowUp:-1, ArrowLeft:-1};
        let next;
        if (event.key in directions) next = (index + directions[event.key] + this.thumbs.length) % this.thumbs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.thumbs.length - 1;
        else return;
        event.preventDefault();
        this.thumbs[next].focus();
        this.select(this.thumbs[next]);
      });
    }
    select(button) {
      this.photo.srcset = button.dataset.srcset;
      this.photo.src = button.dataset.image;
      this.photo.alt = button.dataset.alt;
      this.caption.textContent = button.dataset.name;
      this.thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sr-style-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sr-style-gallery')) {
  customElements.define('sr-style-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.thumbs = [...this.querySelectorAll('[data-style-index]')];
      this.original = this.querySelector('[data-style-original]');
      this.selected = this.querySelector('[data-style-selected]');
      this.caption = this.querySelector('[data-style-caption]');
      this.initialCaption = this.caption.textContent;
      this.resetButton = this.querySelector('[data-style-reset]');
      this.thumbs.forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.select(button);
        });
      });
      this.resetButton?.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        this.original.hidden = false;
        this.selected.hidden = true;
        if (this.classList.contains('sr-style-card--clip')) {
          this.original.style.setProperty('--sr-clip-size', 'contain');
          this.original.style.setProperty('--sr-clip-x', '50%');
          this.original.style.setProperty('--sr-clip-y', '50%');
        }
        this.caption.textContent = this.initialCaption;
        this.thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', 'false'));
        this.thumbs[0]?.focus({ preventScroll: true });
        this.resetButton.hidden = true;
      });
      this.addEventListener('keydown', event => {
        const index = this.thumbs.indexOf(event.target);
        if (index < 0) return;
        const directions = {ArrowDown:1, ArrowRight:1, ArrowUp:-1, ArrowLeft:-1};
        let next;
        if (event.key in directions) next = (index + directions[event.key] + 4) % 4;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = 3;
        else return;
        event.preventDefault();
        this.thumbs[next].focus();
        this.select(this.thumbs[next]);
      });
    }
    select(button) {
      if (this.classList.contains('sr-style-card--clip')) {
        this.original.hidden = false;
        this.selected.hidden = true;
        this.original.style.setProperty('--sr-clip-size', '200% 200%');
        this.original.style.setProperty('--sr-clip-x', button.dataset.styleX);
        this.original.style.setProperty('--sr-clip-y', button.dataset.styleY);
        this.caption.textContent = button.dataset.styleName;
        this.resetButton.hidden = false;
        this.thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
        return;
      }
      const selectedImage = this.selected.querySelector('[data-style-image]');
      if (selectedImage && button.dataset.styleUrl) {
        selectedImage.src = button.dataset.styleUrl;
        selectedImage.alt = button.dataset.styleName;
      }
      this.selected.style.setProperty('--sr-style-x', button.dataset.styleX);
      this.selected.style.setProperty('--sr-style-y', button.dataset.styleY);
      this.selected.style.backgroundPosition = button.dataset.styleX + ' ' + button.dataset.styleY;
      this.selected.setAttribute('aria-label', button.getAttribute('aria-label'));
      this.original.hidden = true;
      this.selected.hidden = false;
      this.caption.textContent = button.dataset.styleName;
      this.resetButton.hidden = false;
      this.thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
